import { render, staticRenderFns } from "./WebhookIntegration.vue?vue&type=template&id=38592544&scoped=true"
import script from "./WebhookIntegration.vue?vue&type=script&lang=js"
export * from "./WebhookIntegration.vue?vue&type=script&lang=js"
import style0 from "./WebhookIntegration.vue?vue&type=style&index=0&id=38592544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38592544",
  null
  
)

export default component.exports